import { BaseModel } from '../../../models/base-model'

export class ProductRecommendation extends BaseModel {
  public name: string
  public description: string
  public price: string
  public cartUrl: string
  public lastPurchaseDate: Date
  public testLine: string
  public available: boolean

  public recommendationReason: 'upgrade'|'extension'|'recommendation'
  public recommendedItemType: 'event'|'item'
  public metaData: {[key: string]: string|Date|number|boolean}

  constructor() { super() }

  public getMeta(key, defaultValue?): any {
    if (this.metaData && key in this.metaData) {
      return this.metaData[key]
    }
    return defaultValue
  }

  public isBeforeLastPurchaseDate(): boolean {
    return !this.lastPurchaseDate || (
      this.lastPurchaseDate instanceof Date && (new Date() < this.lastPurchaseDate)
    )
  }

}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/product-recommendation/product-recommendation.ts